import { useMutation, useQuery } from '@tanstack/react-query'
import {
  fetchInventories,
  fetchInventory,
  fetchStoreInventories,
  updateInventoryDescription,
  updateInventoryFinishedStatus,
  updateInventoryStatus,
  updateUnScannableProducts,
} from '../queries/inventories.queries'
import { fetchReapproNeedsByStoreAndDate } from '../queries/stores.queries'

export const useInventories = () =>
  useQuery({
    queryKey: ['inventories'],
    queryFn: fetchInventories,
  })

export const useInventory = (id: number) =>
  useQuery({
    queryKey: ['inventory', id],
    queryFn: () => fetchInventory(id),
  })

export const useStoreInventories = (id: number) =>
  useQuery({
    queryKey: ['storeInventories', id],
    queryFn: () => fetchStoreInventories(id),
  })

export const useUpdateUnScannableProducts = () =>
  useMutation({
    mutationFn: updateUnScannableProducts,
  })

export const useUpdateInventoryDescription = () =>
  useMutation({
    mutationFn: updateInventoryDescription,
  })

export const useUpdateInventoryStatus = () =>
  useMutation({
    mutationFn: updateInventoryStatus,
  })

export const useUpdateInventoryFinishedStatus = () =>
  useMutation({
    mutationFn: updateInventoryFinishedStatus,
  })

export const useReapproNeeds = (storeReference: number | string | undefined, date: string | null) =>
  useQuery({
    queryKey: ['reapproNeeds', storeReference, date],
    queryFn: () => fetchReapproNeedsByStoreAndDate(String(storeReference!), date!),
    enabled: !!storeReference && !!date,
  })
